import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { auth } from "../../api/configFirebase";

//import ButtonBarBoostrap from "../components/ButtonBar/ButtonBarBoostrap";
import { useEffect, useState } from "react";
//import { initializeApp } from "@firebase/app";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Link } from "react-router-dom";
//import ModalRestPassword from "../modals/ModalRestPassword";
import { addCompany } from "../../reducer/actions/actionsCompany";
import "../../css/cssGeneral.css";
import "./FormAddCompany.css";
import { MDBInput } from "mdb-react-ui-kit";
import logoNew from "../../IMAGENES/LogoNew.png";
import { ClipLoader } from "react-spinners";

const FormAddCompany = () => {
  const MySwal = withReactContent(Swal);
  const loginUser = useSelector((state) => state.user.user);
  const navigate = useNavigate();

  //const history = useHistory();
  const dispatch = useDispatch();
  const [stateValue, setStateValue] = useState({
    nameCompany: "",
    address: "",
    cuit: "",
  });


  const [validationName, setValidationName] = useState({
    nameCompany: false,
    cuit: false,
    address: false,
  });
  const [isInputFocusedName, setIsInputFocusedName] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [isLoading, setIsLoading] = useState(false)
  //logIn with email of gmail

  const handleChange = (e) => {
    const { name, value } = e.target;
    setStateValue((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setValidationName((prev) => ({
      ...prev,
      [name]: name === "cuit" ? value.length > 2 : value.length > 2,
    }));
  };

  const handleFocusName = () => {
    setIsInputFocusedName(true);
  };

  const handleChangeRadioB = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleSumbit = async (e) => {
    if (
      stateValue.address.trim() === "" ||
      stateValue.nameCompany.trim() === "" ||
      stateValue.cuit.trim() === ""
    ) {
      MySwal.fire({
        title: "Error Login",
        text: "Se deben Completar Todos los Datos",
        icon: "warning",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "rgb(255, 140, 0)",
      });
    } else {
      try {
        setIsLoading(true)
        const newCompany = await dispatch(
          addCompany({
            nameCompany: stateValue.nameCompany,
            address: stateValue.address,
            cuit: stateValue.cuit,
            province: "Salta",
            country: "Argentina",
            emailUser: loginUser.email,
            category: selectedOption,
            slug: stateValue.nameCompany.toLowerCase().replace(/\s+/g, "-")
          })
        );

        if (newCompany && newCompany.status === 200) {
          setIsLoading(false)
          MySwal.fire({
            title: "¡Empresa Creada!",
            icon: "success",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "rgb(21, 151, 67)",
          })
          navigate("/");
        }
      } catch (error) {
        console.error(error.code, error.message);
      }
    }
  };



  //   const RedirectLink = () => {
  //     window.location.href = "/login";
  //   };
  return (
    <div className="login-wrapAddComp">
      <div className="addComp-htmld">
        <div className="text-center">
          <img src={logoNew} style={{ width: "185px" }} alt="logo" />
          <h4 className="mt-1 mb-3 pb-1">Gestion de Turnos PY</h4>
        </div>

        <p className="text-center">ADHERIR UNA EMPRESA</p>

        <label className="form-label" htmlFor="idNameComp">
          (*) Nombre de la Empresa
        </label>

        <MDBInput
          className="small"
          data-testid="empresa-input"
          wrapperClass="mb-2"
          id="idNameComp"
          type="text"
          name="nameCompany"
          value={stateValue.nameCompany}
          onChange={handleChange}
          onFocus={handleFocusName}
          minLength="2"
          maxLength="30"
        />

        {!validationName.nameCompany && isInputFocusedName && (
          <div className="text-danger msgAlertInput">
            Mayor a 2 letras
          </div>
        )}


        <label className="form-label mt-3" htmlFor="idAddress">
          (*) Domicilio
        </label>

        <MDBInput
          className="small"
          wrapperClass="mb-2"
          data-testid="domicilio-input"
          id="idAddress"
          type="text"
          name="address"
          value={stateValue.address}
          onFocus={handleFocusName}
          onChange={handleChange}
          minLength={2}
          maxLength={30}
        />

        {!validationName.address && isInputFocusedName && (
          <div className="text-danger msgAlertInput">
            Mayor a 2 letras
          </div>
        )}

        <label className="form-label mt-3" htmlFor="idCuit">
          {" "}
          (*) Cuit
        </label>

        <MDBInput
          className="small"
          data-testid="cuit-input"
          wrapperClass="mb-2"
          id="idCuit"
          type="text"
          name="cuit"
          onFocus={handleFocusName}
          value={stateValue.cuit}
          minLength={2}
          maxLength={15}
          required
          onChange={(e) => {
            // Solo permitir números y máximo 15 caracteres
            const value = e.target.value.replace(/\D/g, "").slice(0, 15);
            setStateValue((prevState) => ({
              ...prevState,
              cuit: value,
            }));
          }}
        />

        {!validationName.cuit && isInputFocusedName && stateValue.cuit.length <= 2 && (
          <div className="text-danger msgAlertInput">
            Mayor a 2 números
          </div>
        )}

        <div className="d-flex justify-content-between w-100">
          <label className="p-2">
            <input
              className="m-2"
              type="radio"
              value="pelu"
              checked={selectedOption === "pelu"}
              onChange={handleChangeRadioB}
            />
            Peluqueria
          </label>

          <label className="p-2">
            <input
              className="m-2"
              type="radio"
              value="peluAndVet"
              checked={selectedOption === "peluAndVet"}
              onChange={handleChangeRadioB}
            />
            Veterinaria y Peluqueria
          </label>

          <label className="p-2">
            <input
              className="m-2"
              type="radio"
              value="indumentaria"
              checked={selectedOption === "indumentaria"}
              onChange={handleChangeRadioB}
            />
            Indumentaria
          </label>

        </div>

        <div className="text-danger msgAlertInput">(*) Valores Obligatorios</div>

        {isLoading ?
          <div className="d-flex vh-50 justify-content-center align-items-center flex-column">
            <ClipLoader color="#000" loading={true} size={70} />
            <div className="titGral">
              <h2 className="mt-3">Espere un Momento por favor ...</h2>
            </div>
          </div> :
          <div className="text-center pt-2 mb-5 pb-1">
            {
              <button
                className="btn btn-primary"
                type="submit"
                onClick={handleSumbit}
                disabled={
                  !stateValue.nameCompany.trim() ||
                    validationName.nameCompany === false ||
                    validationName.address === false ||
                    !stateValue.address.trim() ||
                    !stateValue.cuit.trim() ||
                    !selectedOption
                    ? true
                    : false
                }
              >
                Adherir Empresa
              </button>
            }
          </div>
        }

      </div>
    </div>
  );
};

export default FormAddCompany;
